module.exports = __webpack_public_path__ + "img/15.03b2241a.png";